export default {"src":"/_next/static/media/MariaDB.bf2830b8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};